import { render, staticRenderFns } from "./HeroSass.vue?vue&type=template&id=53b50776&scoped=true&"
import script from "./HeroSass.vue?vue&type=script&lang=js&"
export * from "./HeroSass.vue?vue&type=script&lang=js&"
import style0 from "./HeroSass.vue?vue&type=style&index=0&id=53b50776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b50776",
  null
  
)

export default component.exports